// Shared IO Mapping value-colour palette + helper.
//
// SINGLE SOURCE OF TRUTH for the colours an operator can assign to an IO
// element's output in Device Management → IO Mapping. Every surface that
// *renders* those colours (Live Tracking TelemetryPanel, the Public Tracking
// page) must read from here so the palette can never drift out of sync again
// (e.g. a colour added to the picker but missing from a render surface — which
// previously caused "yellow" to silently fall back to the default text colour).
//
// `class` = Tailwind text colour used when rendering the value.
// `bg`    = swatch background used by the picker UI.
// The literal class strings live in this file so Tailwind's content scanner
// (./src/**/*.{js,jsx,ts,tsx}) keeps them in the build.
export const IO_VALUE_COLOR_OPTIONS = [
  { value: '', label: 'Default', class: '' },
  { value: 'red', label: 'Red', class: 'text-red-500', bg: 'bg-red-500' },
  { value: 'green', label: 'Green', class: 'text-green-500', bg: 'bg-green-500' },
  { value: 'blue', label: 'Blue', class: 'text-blue-500', bg: 'bg-blue-500' },
  { value: 'orange', label: 'Orange', class: 'text-orange-500', bg: 'bg-orange-500' },
  { value: 'purple', label: 'Purple', class: 'text-purple-500', bg: 'bg-purple-500' },
  { value: 'teal', label: 'Teal', class: 'text-teal-500', bg: 'bg-teal-500' },
  { value: 'amber', label: 'Amber', class: 'text-amber-500', bg: 'bg-amber-500' },
  { value: 'rose', label: 'Rose', class: 'text-rose-500', bg: 'bg-rose-500' },
  { value: 'yellow', label: 'Yellow', class: 'text-yellow-400', bg: 'bg-yellow-400' },
];

// Resolve a Tailwind text-colour class for a display value, given the mapping's
// `value_colors` map. Falls back to the per-mapping '_default' colour, else none.
// Guarded: returns '' for empty/missing values so unset values keep the default
// (light/dark theme) text colour. Used by the read-only render surfaces.
// Matching order: exact trimmed value first (multi-word logic labels like
// "NOT CHARGING"), then unit-stripped (numeric values rendered as "12.57 V").
export const getIoValueColorClass = (displayVal, valueColors) => {
  if (!valueColors || !displayVal) return '';
  const raw = String(displayVal).trim();
  const color = valueColors[raw]
    ?? valueColors[raw.replace(/ .+$/, '')]
    ?? valueColors['_default'] ?? '';
  const opt = IO_VALUE_COLOR_OPTIONS.find(o => o.value === color);
  return opt?.class || '';
};
